import React, {PropTypes} from 'react';
import moment from 'moment';

class CalendarPrices extends React.Component {

  constructor() {
    super();
    this.skyscannerMonths = this.skyscannerMonths.bind(this);
    this.findPriceByDate = this.findPriceByDate.bind(this);
    this.findCheapestPrice = this.findCheapestPrice.bind(this);
    this.convertToCurrency = this.convertToCurrency.bind(this);
    this.numberWithCommas = this.numberWithCommas.bind(this);
  }

  convertToCurrency(price) {
    let rates = this.props.currencies.rates;
    let currency_code = this.props.userLocation.currency_code;
    let converted = (price * rates[currency_code]);
    let rounded = Math.round(converted);
    return rounded;
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Returns months like in Skyscanner's grids'
  // ["2017-02", "2017-03", "2017-04" ...]
  skyscannerMonths () {
    let months = [];
    let this_year = (new Date()).getFullYear();
    let start = new Date("1/1/" + this_year);
    let moment_start = moment(start.valueOf());
    months.push(moment_start.format("YYYY-MM"));
    for (let i=0; i<11; i++){
      months.push(moment_start.add(1, 'month').format("YYYY-MM"));
    }
    return months;
  }

  // For a date like "2017-04", find a price in the grid
  // returns undefined or an integer
  findPriceByDate (grid, date) {
    return grid[date];
  }

  findCheapestPrice(grid) {
    let min;
    for (let key in grid){
      if(min === undefined) {
        min = grid[key];
      }
      if(grid[key] < min){
        min = grid[key];
      }
    }
    return min;
  }

  findHighestPrice(grid) {
    let max;
    for (let key in grid){
      if(max === undefined) {
        max = grid[key];
      }
      if(grid[key] > max){
        max = grid[key];
      }
    }
    return max;
  }

  render() {
    let prices = this.props.prices;
    let pricesArray = [];

    let months = this.skyscannerMonths();
    let grid_table_cells = [];
    let cheapest_price = this.findCheapestPrice(prices.grid);
    let highest_price = this.findHighestPrice(prices.grid);
    let value;

    // For each month
    for (let i=0; i<months.length; i++){
      let price = this.findPriceByDate(prices.grid, months[i]);

      // Define if this month is selected
      let selected = '';
      if (i + 1 == this.props.selection.currentMonth) {
        selected = 'selected';
      }

      // Class for cheap flights
      let cheapness = '';
      if(price > highest_price * 0.95){
        //cheapness = 'expensive';
      }
      if(price < cheapest_price * 1.02){
        cheapness = 'cheap';
      }
      if(price === cheapest_price){
        //cheapness = 'cheap';
      }

      // Converted
      let converted = this.convertToCurrency(price) || '-';

      // Loading indicator
      if(this.props.isFetching){
        value = '...' ;
      }
      else {
        value = this.numberWithCommas(converted);
      }

      grid_table_cells.push(
        <td className={cheapness} key={i}>
          <span className={selected}>{value}</span>
        </td>
      );
    }

    // Initial width
    let tableStyle = {
      width: this.props.initialWidth
    };

    pricesArray.push(
      <div key={prices.to_city_id}>
        <table className="prices" style={tableStyle}>
          <tbody>
            <tr>
              {grid_table_cells}
            </tr>
          </tbody>
        </table>
        <div className="metric-title">{prices.to_city_name}</div>
      </div>
    );

    return (
      <div>
        {pricesArray}
      </div>
    );
  }
}

CalendarPrices.propTypes = {
  prices: PropTypes.object.isRequired,
  currencies: PropTypes.object.isRequired,
  selection: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  userLocation: PropTypes.object.isRequired,
  initialWidth: PropTypes.string.isRequired
};

export default CalendarPrices;



/** WEBPACK FOOTER **
 ** ./src/components/CalendarPrices.js
 **/